export const ROLES = {
  USER: "user",
};

export default ROLES;
